import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { ApplicationRef, DoBootstrap, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import localeRo from '@angular/common/locales/ro';
import { IonicModule, IonicRouteStrategy, Platform } from '@ionic/angular';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';

import { IConfig, NgxMaskModule } from 'ngx-mask';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TokenInterceptor } from './services';
import {
    AuthFacade,
    AuthState,
    CartState,
    LandingState,
    ProductsState,
    SearchState,
    SellNowState
} from './store';

import { BlankLayoutComponent, SideMenuLayoutComponent } from './layouts';
import intlTelInput from 'intl-tel-input';

export const httpLoaderFactory = (http: HttpClient) => new TranslateHttpLoader(http);

export const options: Partial<null | IConfig> | (() => Partial<IConfig>) = null;

// Register locale data
registerLocaleData(localeRo, 'ro');

@NgModule({
    declarations: [AppComponent, BlankLayoutComponent, SideMenuLayoutComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        IonicModule.forRoot({
            backButtonText: '',
            mode: 'md'
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient]
            }
            // defaultLanguage: 'ro'
        }),
        NgxsModule.forRoot([ProductsState, AuthState, LandingState, SearchState, CartState, SellNowState], {
            developmentMode: !environment.production
        }),
        NgxsStoragePluginModule.forRoot({
            key: ['auth.token', 'auth.pbToken', 'products.favBrands', 'sellNow.intro']
        }),
        environment.plugins,
        AppRoutingModule,
        NgxMaskModule.forRoot()
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        }
    ]
})
export class AppModule implements DoBootstrap {
    constructor(private authFacade: AuthFacade, private platform: Platform, private translate: TranslateService) {}
    ngDoBootstrap(appRef: ApplicationRef) {
        this.translate.setDefaultLang('ro');
        appRef.bootstrap(AppComponent);

        this.platform
            .ready()
            .then(async () => {
                intlTelInput.loadUtils('https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/23.1.0/js/utils.min.js');
                await this.getPublicToken();
            })
            .catch((error) => {
                console.warn('App background initialization failed', error);
            });
    }

    private async getPublicToken() {
        try {
            await this.authFacade.ensurePublicToken();
        } catch (error) {
            console.warn('GetPublicToken failed', error);
        }
    }
}
